// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"DeleteModal_modal_wrapper__xiW5j","actionWrapper":"DeleteModal_actionWrapper__SoTS-","textWrapper":"DeleteModal_textWrapper__UTOks","text":"DeleteModal_text__YxKrI"};